import { ApiService } from '../services/Api';
import { Bot, Reply } from '../interfaces';
import { formatDocumentProperty, transformToLocalStructure } from '../utils/categoryTransform.ts';
import { createToast } from '../components/Toast/createToast.ts';
import { IToast } from '../components/Toast/index.tsx';

const MAX_RETRIES = 3;
const RETRY_DELAY = 1000;

const retryRequest = async (requestFn: () => Promise<void>, retries = MAX_RETRIES, delay = RETRY_DELAY) => {
  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      await requestFn();
      return; 
    } catch (error) {
      console.error(`Attempt ${attempt} failed. Retrying in ${delay}ms...`, error);
      if (attempt < retries) {
        await new Promise((resolve) => setTimeout(resolve, delay));
        delay *= 2;
      } else {
        throw error; 
      }
    }
  }
};

export const fetchReplies = async (apiService: ApiService, botRef: Bot | null) => {
  try {
    if (!botRef) {
      createToast('failed');
      return;
    }
    const data = await apiService.get(
      `/Tenants/${botRef.tenantId}/Bots/${botRef.transhipmentSkill}/Attendance/Replies?loadChildren=true`
    );
    return transformToLocalStructure(data);
  } catch (error) {
    createToast('failed');
    console.error('Error fetching categories:', error);
  }
};

export const editReplies = async (apiService: ApiService, categoryId: string, replies: Reply[], 
  botRefs: Bot[] ) => {
    let result: IToast = "success";
    const updatedReplies = formatDocumentProperty(replies);
    try {
      await Promise.all(
        botRefs.map(async (botRef) =>
          retryRequest(async () => {
            await apiService.post(
              `/Tenants/${botRef.tenantId}/Bots/${botRef.transhipmentSkill}/Attendance/Replies`,
              {
                categoryId,
                replies: updatedReplies,
              }
            );
          })
        )
      );
    } catch (error) {
      console.error("Error editing replies for multiple bots:", error);
      result = "failed";
    }
  createToast(result);
  return result;
}

export const deleteCategory = async (apiService: ApiService, categoryId: string, 
  botRefs: Bot[] ) => {
    let result: IToast = "success";

  try {
    await Promise.all(
      botRefs.map(async (botRef) =>
        retryRequest(async () => {
          await apiService.delete(
            `/Tenants/${botRef.tenantId}/Bots/${botRef.transhipmentSkill}/Attendance/Replies/${categoryId}`
          );
        })
      )
    );
  } catch (error) {
    console.error("Error deleting categories for multiple bots:", error);
    result = "failed";
  }
    createToast(result);
    return result;
}